import { render, staticRenderFns } from "./ListaNotasFiscais.vue?vue&type=template&id=13b08065&"
import script from "./ListaNotasFiscais.vue?vue&type=script&lang=js&"
export * from "./ListaNotasFiscais.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports